import * as React from 'react';
import { Component } from 'react';
import { withTheme } from 'styled-components';
import { styled } from '../utils/styled';
import { propStyles } from '../utils/propStyles';
import { Spinner } from './Spinner';
import Translate from './Translate';
import { observer } from 'mobx-react';
import { inject } from '../utils';
import { AccessibilityStore } from '../stores';
import { Theme } from '../models/Theme';

interface LoadMoreButtonProps {
    theme?: Theme;
    onClick: () => void;
    disabled: boolean;
    isLoading: boolean;
    show?: boolean;
    accessibilityStore?: AccessibilityStore;
}

const Button = styled<any, any>('button', 'button', 'loadMoreButton')`
    ${propStyles};
    outline: none;
    cursor: pointer;
    opacity: ${p => (p.disabled ? 0.5 : 1)};
`;

Button.defaultProps = {
    show: true,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    paddingX: 'md',
    paddingY: 'sm',
    marginY: 'md',
    height: '40px',
    minHeight: '40px',
    minWidth: '30%',
    fontSize: 'inherit',
    fontFamily: 'heading',
    fontWeight: 'medium',
    textTransform: 'uppercase',
    borderRadius: 'sm',
    borderStyle: 'none',
    boxShadow: 'sm',
    textAlign: 'center',
    color: 'white',
    bgColor: 'primary',
};
@inject('accessibilityStore')
@observer
class LoadMoreButton extends Component<LoadMoreButtonProps> {
    render() {
        const {
            theme,
            onClick,
            disabled,
            show,
            accessibilityStore,
            isLoading,
            ...props
        } = this.props;
        if (!show) {
            return null;
        }
        return (
            <Button
                aria-label={accessibilityStore.buttonAccessibilityValue(
                    'LoadMoreButton'
                )}
                onClick={onClick}
                disabled={disabled}
                {...props}
                {...theme.MoreButton}
            >
                {isLoading && (
                    <span>
                        <Spinner iconSize="16px" marginX="sm" />
                        <Translate>Loading</Translate>
                    </span>
                )}
                {!isLoading && (
                    <span>
                        <Translate>Load More</Translate>
                    </span>
                )}
            </Button>
        );
    }
}

export default withTheme(LoadMoreButton) as any;



// WEBPACK FOOTER //
// ./src/Components/LoadMoreButton.tsx